module.exports = __webpack_public_path__ + "img/1.b87948cf.jpg";